import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDarkModeProfileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#323E54' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M9.523 17.315c.27 3.862 3.547 7.005 7.47 7.177a7.88 7.88 0 0 0 6.727-3.202c.615-.833.285-1.388-.742-1.2a7 7 0 0 1-1.56.105c-3.668-.15-6.668-3.218-6.683-6.84a6.7 6.7 0 0 1 .563-2.738c.405-.93-.083-1.372-1.02-.975-2.97 1.253-5.003 4.245-4.755 7.673'
    />
  </svg>
);
export default SvgDarkModeProfileMenu;
